// extracted by mini-css-extract-plugin
module.exports = {"Dim":"_2kKBzp1Cuj93qOFUvpfxih"};